export default __webpack_public_path__ + "static/images/referral-page-twitter-196dec982204f0b1ec9dbfeaaa8ed646.jpg";